module.exports = __webpack_public_path__ + "static/media/tall_curvy_underline.a6928151.svg";